export const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_BROWSER_KEY || '';
export const mapsMapId = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || '';

export const isMapConfigured = () => Boolean(mapsApiKey && mapsMapId);
